import { Modal } from "@mantine/core";
import {
  GetTransactionsResponse,
  TransactionResponse,
} from "../../../../../types/transactions";
import { BusinessInfo } from "../../../../../types/context";
import { ServicePackage } from "../../../../../types/packages";
import TransactionBookedServiceModal from "./TransactionBookedServiceModal/TransactionBookedServiceModal";
import ProductForm from "./ProductForm";
import AddPackageLineItem from "./AddPackageLineItem";
import GiftCardLineItemForm from "./GiftCardLineItemForm";
import { useResponsive } from "../../../../../context/ResponsiveContext";

interface AddLineItemModalProps {
  opened: boolean;
  onClose: () => void;
  lineItemType: "service" | "product" | "package" | "giftcard";
  transaction: GetTransactionsResponse | TransactionResponse;
  businessInfo: BusinessInfo | null;
  /** Salon packages/specials pre-fetched by TransactionDetailModal, passed to
   *  the picker so it doesn't refetch. */
  salonPackages?: ServicePackage[];
  onLineItemAdded: (response: any) => void;
}

export default function AddLineItemModal({
  opened,
  onClose,
  lineItemType,
  transaction,
  businessInfo,
  salonPackages,
  onLineItemAdded,
}: AddLineItemModalProps) {
  const { isMobile } = useResponsive();
  const handleSubmit = (lineItemData: any) => {
    onLineItemAdded(lineItemData);
  };

  const getModalTitle = () => {
    if (lineItemType === "service") return "Add Service";
    if (lineItemType === "package") return "Sell a Package or Special";
    if (lineItemType === "giftcard") return "Sell a Gift Card";
    return "Add Product";
  };

  const renderContent = () => {
    if (lineItemType === "service") {
      return (
        <TransactionBookedServiceModal
          mode="add"
          transaction={transaction}
          businessInfo={businessInfo}
          onSubmit={handleSubmit}
          onCancel={onClose}
        />
      );
    }
    if (lineItemType === "package") {
      return (
        <AddPackageLineItem
          salonId={businessInfo?.id ?? ""}
          timezone={businessInfo?.timezone}
          packages={salonPackages}
          onSubmit={handleSubmit}
        />
      );
    }
    if (lineItemType === "giftcard") {
      return (
        <GiftCardLineItemForm
          salonId={businessInfo?.id ?? ""}
          onSubmit={handleSubmit}
          onCancel={onClose}
        />
      );
    }
    return (
      <ProductForm
        mode="add"
        transaction={transaction}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    );
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={getModalTitle()}
      size="lg"
      fullScreen={isMobile}
      centered
      withCloseButton
    >
      {renderContent() || <div>Loading...</div>}
    </Modal>
  );
}
